import React from "react";
import logo from "../assets/SVG/Logo_new.svg";
import img from "../assets/login_img.png";
import bg from "../assets/about3.png";
import { isBitramp } from "@/utils/utils";
import bg_Bitramp from "../assets/SVG/bg_Bitramp.svg";
import logo_Bitramp from "../assets/SVG/logo_Bitramp.svg";
import img_Bitramp from "../assets/SVG/img_Bitramp.svg";
import { Link } from "react-router-dom";
import { RoutesPathList } from "@/config/routes/Routes";

const RegisterConfirm: React.FC = () => {
  return isBitramp() ? (
    <div className="register">
      <img className="register__bg__img_bitramp" src={bg_Bitramp} alt="bg" />
      <div className="register__left">
        <div className="register__left__logo">
          <img className="w-[7rem] h-[4rem]" src={logo_Bitramp} alt="logo" />
        </div>
        <div className="register__left__image">
          <img
            className="register__left__image--resize"
            src={img_Bitramp}
            alt="img"
          />
        </div>
        <div className="register__left__text">Get Started Now</div>
      </div>
      <div className="rounded-[20px]  bg-[#2B2B2B] w-[40%] min-w-[20rem] pt-[7rem] pb-[2rem] px-[5rem] flex items-center flex-col z-[99999] overflow-hidden font-satoshi">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="49"
          viewBox="0 0 72 49"
          fill="none"
        >
          <g clip-path="url(#clip0_4446_19035)">
            <path
              d="M72 41.6511V45.8816C71.3749 47.3044 70.3085 48.3737 68.8723 49.0001H3.20616C1.72072 48.3089 0.244247 47.074 0.0739702 45.3312C0.0134773 44.7115 -0.011168 42.0471 0.190475 41.6489L20.7446 25.1567L35.9418 32.7473L36.4974 32.6444L50.7715 25.2708L51.5266 25.197L72 41.6511Z"
              fill="#8AFEFD"
            />
            <path
              d="M71.9998 3.12304V7.57718L35.9639 25.8031L0.107332 7.43848C-0.201854 4.1745 -0.0831084 0.738255 3.75931 0H68.3209C70.0707 0.170022 71.3075 1.6443 71.9998 3.12304Z"
              fill="#8AFEFD"
            />
            <path
              d="M71.9999 36.3065L55.4741 23.0559L71.9999 14.481V36.3065Z"
              fill="#8AFEFD"
            />
            <path
              d="M0.0805664 36.3065V14.481L16.6063 23.0559L0.0805664 36.3065Z"
              fill="#8AFEFD"
            />
          </g>
          <defs>
            <clipPath id="clip0_4446_19035">
              <rect width="72" height="49" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div className="mt-[2rem] white">Check your inbox!</div>
        <div className="white">
          We’ve sent you a <span className="font-bold white">confirmation</span>{" "}
          email
        </div>
        <Link to={RoutesPathList.Login} className="Primary_button mt-2">Log in</Link>
      </div>
    </div>
  ) : (
    <div className="register">
      <img className="register__bg__img" src={bg} alt="bg" />
      <div className="register__left">
        <div className="register__left__logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="register__left__image">
          <img className="register__left__image--resize" src={img} alt="img" />
        </div>
        <div className="register__left__text">Get Started Now</div>
      </div>
      <div className="rounded-[20px] border border-[#F8F9FA] bg-white shadow-[0px_4px_20px_0px_rgba(238,238,238,0.50)] w-[40%] min-w-[20rem] pt-[7rem] pb-[2rem] px-[5rem] flex items-center flex-col z-[99999] overflow-hidden font-satoshi">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="49"
          viewBox="0 0 72 49"
          fill="none"
        >
          <g clip-path="url(#clip0_3498_7236)">
            <path
              d="M72 41.6511V45.8816C71.3749 47.3044 70.3085 48.3737 68.8723 49.0001H3.20616C1.72072 48.3089 0.244247 47.074 0.0739702 45.3312C0.0134773 44.7115 -0.011168 42.0471 0.190475 41.6489L20.7446 25.1567L35.9418 32.7473L36.4974 32.6444L50.7715 25.2708L51.5266 25.197L72 41.6511Z"
              fill="#DCDCDC"
            />
            <path
              d="M71.9998 3.12304V7.57718L35.9639 25.8031L0.107332 7.43848C-0.201854 4.1745 -0.0831084 0.738255 3.75931 0H68.3209C70.0707 0.170022 71.3075 1.6443 71.9998 3.12304Z"
              fill="#DCDCDC"
            />
            <path
              d="M71.9999 36.3065L55.4741 23.0559L71.9999 14.481V36.3065Z"
              fill="#DCDCDC"
            />
            <path
              d="M0.0805664 36.3065V14.481L16.6063 23.0559L0.0805664 36.3065Z"
              fill="#DCDCDC"
            />
          </g>
          <defs>
            <clipPath id="clip0_3498_7236">
              <rect width="72" height="49" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div className="mt-[2rem]">Check your inbox!</div>
        <div>
          We’ve sent you a <span className="font-bold">confirmation</span> email
        </div>
        <Link to={RoutesPathList.Login} className="Primary_button mt-[2rem]">Log in</Link>
      </div>
    </div>
  );
};

export default RegisterConfirm;
